<template>
  <div>
    <div>{{ location.province }}</div>
    <div>{{ location.city }}</div>
    <baidu-map class="map">
      <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :showAddressBar="true"
        :autoLocation="true"
      ></bm-geolocation>
    </baidu-map>
  </div>
</template>

<script>
import BMap from "vue-baidu-map"
export default {
  name: "Location",
  data() {
    return {
      location: {
        //给渲染层定义一个初始值
        province: "广东省",
        city: "广州市"
      }
    };
  },
  mounted() {
    //触发获取城市方法
    //this.get_current_city();
  },
  methods: {
    get_current_city() {
      //定义获取城市方法
      const geolocation = new BMap.Geolocation();
      var _this = this;
      geolocation.getCurrentPosition(
        position => {
          //console.log(position.address);
          _this.location.province = position.address.province;
          _this.location.city = position.address.city;
        },
        e => {
          _this.LocationCity = "定位失败"
        },
        { provider: "baidu" }
      );
    }
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 300px;
}
</style>
